import { render, staticRenderFns } from "./DashboardEnseigneCard.vue?vue&type=template&id=97ac0a50&"
import script from "./DashboardEnseigneCard.vue?vue&type=script&lang=ts&"
export * from "./DashboardEnseigneCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports